/* eslint-disable max-len */
import React from 'react';
import { addItemsToCart } from '../../../api/cartApi';
import Swatch from '../../configurator/templates/SwatchAltStyle/Swatch';
import { usePlaConfigurationsParams } from '../../../../pages/hooks';

const getChoiceData = (color, selectedColorId) => ({
  shortLabel: color.name,
  mediaUrl: color.imageUrl,
  isAvailable: true,
  isSelected: color.id === selectedColorId,
  price: color.price,
  originalPrice: color.originalPrice,
  sampleData: color.sampleData,
  brand: color.brand,
});

const ColorSwatches = ({
  colors,
  storeNumber,
  setSelectedColor,
  selectedColorId,
  quickViewRef,
  setQuickView,
  onUserHasChangedColor,
  startUpdatePlaConfiguredPrice,
  updateCurrentSku,
  allSurfaceColors,
  selectedThickness
}) => {

  const { plaGuid } = usePlaConfigurationsParams();

  return (
    colors.map((color) => (
      <Swatch
        key={color.id}
        choice={getChoiceData(color, selectedColorId)}
        onClick={() => {
          onUserHasChangedColor(color, true);
          if (plaGuid) {
            startUpdatePlaConfiguredPrice(color);
            const sku = allSurfaceColors.find((surfaceColor) => surfaceColor.optionId === color.externalId && surfaceColor.height === selectedThickness)?.sku;
            updateCurrentSku(selectedThickness, sku);
          }
          setSelectedColor(color);
        }}
        onAddSampleToCart={() => addItemsToCart(storeNumber, color.sampleData)}
        storeNumber={storeNumber}
        quickViewRef={quickViewRef}
        setQuickView={setQuickView}
      />
    ))
  );
};

export default ColorSwatches;
